<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        x-small
        v-on="on"
      >
        파일정보
      </v-btn>
    </template>
    <div>
      <v-card class="card-container">
        <v-card-title class="headline">
          {{ model.raw.rentalcompanyName }} 마이그레이션 데이터
        </v-card-title>
        <v-list class="card-list">
          <v-list-item-group v-for="(item,iIdx) in items" :key="iIdx">
            <v-list-item>
              <v-list-item-content class="ml-6">
                <div class="text-one-line d-flex justify-start">
                  {{ item.originalFilename }}
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <div class="d-flex">
                  <v-btn @click="download(item.path, item.originalFilename)">
                    다운받기
                  </v-btn>
                  <v-btn class="ml-3" @click="deleteData(item.fileId)">
                    삭제
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>
            <v-divider />
          </v-list-item-group>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="close">
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import {PATH} from "@/constants";

export default {
  name: "MigrationDataModal",
  props: {
    model: undefined,
  },
  data() {
    return {
      dialog: false,
      items: []
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const data = await this.model.getMigrationDataList(this.model?._item?.rentalcompanyId);
      this.items = data.data;
    },

    download(path, name) {
      try {
        const url = `${PATH.BASE_URL}${PATH.FILE.FILE2}?path=${encodeURI(path)}&filename=${encodeURI(name)}`;
        window.open(url, "_blank");
      } catch (e) {
        console.error(e);
        this.$alert("파일 경로가 올바르지 않습니다.");
      }
    },

    async deleteFile(id) {
      return await this.$request(PATH.MEMBERSHIP.DELETE_MIGRATION_DATA + id)
        .loading()
        .catch()
        .enqueue();
    },


    async deleteData(id) {
      this.$confirm("정말 삭제하시겠습니까?")
        .then(async () => {
          await this.deleteFile(id);
          await this.load();
        });
    },

    close() {
      this.dialog = false;
    },
  }
}
</script>

<style scoped>
.card-container {
  height: 550px;
}

.card-list {
  overflow-y: scroll;
  border: 1px solid grey;
  height: 410px;
  margin: 10px;
}

.text-one-line {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>